













import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import { onMounted, ref } from "@vue/composition-api";
import WhereDashboard from "./WhereDashboard.vue";
export default Vue.extend({
  components: {
    Modal,
    WhereDashboard,
  },

  props: ["modalData"],
  setup() {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "90rem",
      height: "70rem",
      withTopRightCloseBtn: true,
    };

    const is_modal_open = ref(false);
    onMounted(() => {
      setTimeout(() => {
        is_modal_open.value = true;
      }, 300);
    });

    return {
      config,
      is_modal_open,
    };
  },
});
